import React from 'react';

import { Text } from 'Components/Base';

import NoInternetIllustration from './NoInternetIllustration';

const NoInternetConnectionContent = () => {
  return (
    <>
      <NoInternetIllustration />
      <Text
        mt={6}
        textAlign={'center'}
        fontFamily={"'IBM Plex Sans Thai Looped', Anuphan, sans-serif"}
        textStyle="heading5"
        color={'eggSpace.gray.900'}
      >
        {'อินเทอร์เน็ตไม่เสถียร'}
      </Text>
      <Text
        mt={2}
        textAlign={'center'}
        fontFamily={"'IBM Plex Sans Thai Looped', Anuphan, sans-serif"}
        textStyle="body2"
        color={'eggSpace.gray.600'}
      >
        {'กรุณาตรวจสอบการเชื่อมต่อ และกดเชื่อมต่อ'}
        <br />
        {'หรือเปิดใช้งาน Learn Anywhere ใหม่อีกครั้ง'}
      </Text>
    </>
  );
};

export default NoInternetConnectionContent;
